import { Link } from "react-router-dom";
import Brand from "../components/Brand";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { useTranslation } from "../components/Localization";

export default function HomePage() {
  const { t } = useTranslation();
  return (
    <main className="screen home">
      <Brand />
      <LanguageSwitcher />
      <div className="home-actions">
        <Link className="outline-button" to="/tarlatvezetes">
          {t("home.tour")}
        </Link>
        <Link className="outline-button" to="/attekinto">
          {t("home.overview")}
        </Link>
      </div>
    </main>
  );
}
